import { network } from 'services/network';

export const bulkAssignTagsToCards = (params) => {
    return network.post('api/bo/bulkAssignTagsToCards', params).then((response) => {
        return response.data;
    });
};
